import { Currency } from '../interfaces/currency';


export interface PnpBudgetItem {
    pnp_id: number;
    pnp_group_id: string;
    assigned_amount: number;
    used_amount: number;
    cart_total_amount: number;
    remaining_amount: number;
}


export class PnpBudget {
    public id: number;
    public name: string;
    public budget_used: number;
    public budget_remaining: number;
    public budget_ytd: number;
    public budget_total: number;
    public group_id: number;
    public currency: Currency;
    public distributors: PnpBudgetItem[];
    public budget_groups: PnpBudgetItem[];


    public allItems: PnpBudgetItem[]; /// join of distributors and budget groups

    constructor(data) {
        if (typeof data === 'string') {
            data = JSON.parse(data);
        }
        if (data) {
            Object.assign(this, data);
        }

        if (!this.distributors) {
            this.distributors = [];
        }
        if (!this.budget_groups) {
            this.budget_groups = [];
        }

        if (!this.currency) {
            this.currency = { code: 'USD', symbol: '$' };
        }


        //  remove duplicates from distributors and budget groups based on pnp_group_id and create allItems
        const combined = [...this.budget_groups, ...this.distributors];
        const seen = new Set<string>();
        this.allItems = combined.filter(item => {
            if (seen.has(item.pnp_group_id)) {
                return false;
            }
            seen.add(item.pnp_group_id);
            return true;
        });
    }
}
